import { HttpClient, buildParams } from '@opallabs/api'
import { jsonApiWrapper } from '../../../jsonApiParser'
import { loadJsonApiEntities } from '../../loadJsonApiEntities'

const fetchContentType = (contentTypeId) =>
  HttpClient().get(
    `/api/v1/content_types/${contentTypeId}`,
    buildParams({
      include: ['displays', 'displays.sections', 'options'],
    })
  )

const getContentTypeById = (contentTypeId) => (dispatch, getState) => {
  const contentTypes = getState().jsonApiEntities['content-types']

  if (contentTypes && contentTypes[contentTypeId]) {
    return Promise.resolve(
      jsonApiWrapper({
        data: getState().jsonApiEntities['content-types'][contentTypeId],
        state: getState(),
      })
    )
  }

  return fetchContentType(contentTypeId).then((response) => {
    const jsonApiResponse = response.data
    dispatch(loadJsonApiEntities(jsonApiResponse))
    return jsonApiWrapper({
      data: getState().jsonApiEntities['content-types'][
        jsonApiResponse.data.id
      ],
      state: getState(),
    })
  })
}

export default getContentTypeById
